import React from 'react';
import PropTypes from 'prop-types';
import keyMirror from 'keymirror';
import cn from 'classnames';
import Button from 'react-bootstrap/lib/Button';

import t from '../../lib/I18n';
import Favourite from '../../records/Favourite';

import Icon from '../general/Icon';

export const ButtonSizes = keyMirror({
    SM: null,
    MD: null,
});

const FavouriteButton = ({
    ariaLabel,
    className,
    disabled = false,
    favourite,
    fullWidth = false,
    loading,
    onClick,
    size = ButtonSizes.MD,
    activeText = 'account.orders.favourite.added',
    notActiveText = 'account.orders.favourite.add',
    noText = false,
}) => {
    const baseClass = 'favourite-btn';
    const buttonClassNames = cn(baseClass, 'btn-squarish', {
        [`${baseClass}--sm`]: size === ButtonSizes.SM,
        [`${baseClass}--full-width`]: fullWidth,
    }, className);

    let iconName = 'favourite-add';
    let iconClassName;
    if (loading) {
        iconName = 'spinner';
        iconClassName = 'otrl-spin';
    } else if (favourite) {
        iconName = 'favourite';
    }

    const renderText = () => {
        if (noText) {
            return null;
        }
        return (
            <span className='favourite-btn__text'>
                {favourite ? t(activeText) : t(notActiveText)}
            </span>
        );
    };

    return (
        <Button
            aria-label={ariaLabel}
            className={buttonClassNames}
            disabled={loading || disabled}
            onClick={onClick}
            type="button"
        >
            <Icon className={iconClassName} icon={iconName} />
            {renderText()}
        </Button>
    );
};

FavouriteButton.propTypes = {
    ariaLabel: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    favourite: PropTypes.instanceOf(Favourite),
    fullWidth: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    size: PropTypes.bool,
    activeText: PropTypes.string,
    notActiveText: PropTypes.string,
    noText: PropTypes.bool
};

export default FavouriteButton;
